import { ReactNode } from 'react';
import { PagesConfigKey } from './pages-config';
import { useUserSettings } from '../utils/use-user-settings';
import SharedPageHeader from './shared-page-header';
import Box from '@mui/material/Box';

export interface BreadcrumbItem {
  label: string;
  path?: string;
  onClick?: () => void;
}

interface SimpleBreadcrumbsPageProps {
  bookmarkKey?: PagesConfigKey;
  breadcrumbs?: BreadcrumbItem[];
  children: ReactNode;
  infoTooltip?: string;
  topContent?: React.ReactNode;
  heightOfTopContent?: number;
  shouldAllowHeightToScroll?: boolean;
  isSubPage?: boolean;
  headerActions?: React.ReactNode;
  isSubTabs?: boolean;
}

export default function SimpleBreadcrumbsPage({
  bookmarkKey,
  breadcrumbs,
  children,
  infoTooltip,
  topContent,
  heightOfTopContent,
  shouldAllowHeightToScroll,
  isSubPage = false,
  headerActions,
  isSubTabs = false,
}: SimpleBreadcrumbsPageProps) {
  const { marketingOverview } = useUserSettings();
  const heightOfMarketingOverview = marketingOverview ? 48 : 0;
  const baseSize = isSubPage ? '125px' : '135px';

  return (
    <Box
      sx={{
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <SharedPageHeader
        bookmarkKey={bookmarkKey}
        breadcrumbs={breadcrumbs ?? []}
        infoTooltip={infoTooltip}
        isSubPage={isSubPage}
        headerActions={headerActions}
      />
      {topContent ? (
        <Box sx={{ width: '100%', mb: isSubTabs ? 0 : 1 }}>{topContent}</Box>
      ) : null}

      <Box
        sx={{
          width: '100%',
          height: shouldAllowHeightToScroll
            ? '100%'
            : heightOfTopContent
            ? `calc(100vh - 145px - ${heightOfTopContent}px - ${heightOfMarketingOverview}px)`
            : `calc(100vh - ${baseSize} - ${heightOfMarketingOverview}px)`,
          ...(topContent &&
            isSubTabs && {
              '& > .MuiDataGrid-root, & > .MuiCard-root, & > .MuiPaper-root': {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
              },
            }),
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
